import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Date = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={color || 'none'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 3V1M5 3V1M2.5 6.5H13.5M2.5 13.5H13.5V3.5H2.5V13.5Z"
        stroke={stroke || 'currentColor'}
      />
    </svg>
  ),
)
Date.displayName = 'Date'

export default Date
